// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2Dztw","footer":"Form_footer__1a-q5"};